// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ScanProductionStepResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/scan_production_step
 *
 * The wire shape carries an `action` discriminator plus action-specific
 * optional fields. Possible actions (matching So_production_logs_model
 * ACTION_* constants and the controller's out-of-order warning):
 *
 *   - info_all_done            — every production step already completed
 *   - reprocess_start          — reopened a reprocess-pending step
 *   - reprocess_complete       — closed a reprocess-pending step
 *   - complete                 — closed an in-progress step normally
 *   - start                    — opened the next expected pending step
 *   - out_of_order_start       — force-opened a non-next pending step
 *   - out_of_order_warning     — non-force scan of a non-next step
 *                                 (returns success=true with the warning)
 *
 * `message` is always present. `warning`, `expected_step`, `scanned_step`
 * and `auto_completed_step` are emitted only by the actions that produce them.
 */
import type { Orders_ScanProductionStepAutoCompletedRow } from './Orders_ScanProductionStepAutoCompletedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ScanProductionStepResponseDados {
action: string
message: string
warning?: boolean
expected_step?: string
scanned_step?: string
auto_completed_step?: Orders_ScanProductionStepAutoCompletedRow
}

export type Orders_ScanProductionStepResponse = ApiResponse<Orders_ScanProductionStepResponseDados>;

registerResponseContract('Orders_ScanProductionStepResponse', {
  action:        { type: 'string',  required: true },
  message:       { type: 'string',  required: true },
  warning:       { type: 'boolean', required: false },
  expected_step: { type: 'string',  required: false },
  scanned_step:  { type: 'string',  required: false },
  auto_completed_step: {
    type: 'object',
    required: false,
    fields: {
      id:   { type: 'number',  required: true },
      name: { type: 'string',  required: true },
    },
  },
})
